import React from 'react';
import { Alert, Card, Space, Switch, Typography } from 'antd';

const { Text } = Typography;

interface Props {
    title: string;
    description: string;
    interpretTextAsJson?: boolean;
    onInterpretTextAsJsonChange?: (value: boolean) => void;
}

export const SectionConfigMeasurementReport: React.FC<Props> = ({
    title,
    description,
    interpretTextAsJson,
    onInterpretTextAsJsonChange,
}) => {
    return (
        <Card size="small" style={{ background: '#f5f5f5' }}>
            <Alert message={title} description={description} type="info" showIcon />
            {onInterpretTextAsJsonChange ? (
                <Space style={{ marginTop: 12 }}>
                    <Switch
                        checked={interpretTextAsJson ?? true}
                        onChange={onInterpretTextAsJsonChange}
                    />
                    <Text>Interpret valid measurement text as JSON by default</Text>
                </Space>
            ) : null}
        </Card>
    );
};

export default SectionConfigMeasurementReport;
